<h1 mat-dialog-title>
  {{title}}
</h1>

<mat-form-field class="wide" appearance="fill">
    <mat-label>{{data.title}}</mat-label>
    <mat-select [(ngModel)]="selectedOption">
        @for (type of data.listOptions; track type) {
        <mat-option [value]="type.value">{{type.viewValue}}</mat-option>
        }
    </mat-select>
</mat-form-field>

<div mat-dialog-actions>
  <button type="button" mat-raised-button color="primary" (click)="onConfirm()">Confirm</button>
  <button type="button" mat-button (click)="onCancel()">Cancel</button>
</div>
